import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { URL } from '../../environments/environment';
import { ApplicationsService } from '../applications/applications.service';
import { ImportFileCsvDto } from '../interfaces/ImportFileCsvDto';
import { Applications } from '../interfaces/application';
import { ConnectionDB } from '../interfaces/connectionDb';
import { ImportFileCsv } from '../interfaces/importFileCsv';
import { ImportFileXlsxCreate } from '../interfaces/importFileXlsxCreate';
import { Script } from '../interfaces/script';
import { ScriptStatus } from '../interfaces/scriptStatus';
import { TablesVisualization } from '../interfaces/tableVisualization';

@Injectable({ providedIn: 'root' })
export class ApplicationService {
  private readonly http = inject(HttpClient);
  private readonly applicationsService = inject(ApplicationsService);

  functionsChanged: Subject<ImportFileCsv[]> = new Subject<ImportFileCsv[]>();

  HEADERS = 'application/json';

  private readonly function: ImportFileCsv[] = [];

  connectionDB: ConnectionDB[] = [];

  getFunctions() {
    return this.function.slice();
  }
  getApplication(): Observable<Applications> {
    return this.http.get<Applications>(`${URL.url}${URL.applications}/${this.applicationsService.myObject.name}`);
  }

  getApplicationByName(appName: string): Observable<Applications> {
    return this.http.get<Applications>(`${URL.url}${URL.applications}/${appName}`);
  }
  getConnections(): Observable<Applications> {
    return null;
  }

  addFunctionImportFileCsv(functionAdded: ImportFileCsv): Observable<ImportFileCsv> {
    const body = JSON.stringify(functionAdded);
    const headers = { 'content-type': this.HEADERS };
    return this.http.put<ImportFileCsv>(`${URL.url}${URL.applications}/${this.applicationsService.myObject.id}/importfilecsv`, body, {
      headers
    });
  }

  addTableVisualization(tableVisualization: TablesVisualization): Observable<TablesVisualization> {
    const body = JSON.stringify(tableVisualization);
    const headers = { 'content-type': this.HEADERS };
    return this.http.put<TablesVisualization>(`${URL.url}${URL.applications}/${this.applicationsService.myObject.id}/table`, body, {
      headers
    });
  }

  updateFunctionImportFileCsv(id: number, data: ImportFileCsvDto): Observable<ImportFileCsv> {
    const body = JSON.stringify(data);
    const headers = { 'content-type': this.HEADERS };
    return this.http.put<ImportFileCsv>(`${URL.url}${URL.importFile}/${id}`, body, { headers });
  }

  updateTableVisualization(id: number, tableVisualization: TablesVisualization): Observable<TablesVisualization> {
    const body = JSON.stringify(tableVisualization);
    const headers = { 'content-type': this.HEADERS };
    return this.http.put<TablesVisualization>(`${URL.url}${URL.table}${id}`, body, { headers });
  }

  addFunctionImportFileXlsx(xlsxFunction: ImportFileXlsxCreate): Observable<void> {
    const body = JSON.stringify(xlsxFunction);
    const headers = { 'content-type': this.HEADERS };
    return this.http.put<void>(`${URL.url}${URL.applications}/${this.applicationsService.myObject.id}/importfilexlsx`, body, { headers });
  }

  runScript(script: Script): Observable<ScriptStatus> {
    return this.http.get<ScriptStatus>(`${URL.url}scripts/run/${script.id}`);
  }

  getScriptStatus(scriptId: number): Observable<ScriptStatus> {
    return this.http.get<ScriptStatus>(`${URL.url}scripts/statuses/${scriptId}`);
  }

  getTheLastScriptStatus(scriptId: number): Observable<ScriptStatus> {
    return this.http.get<ScriptStatus>(`${URL.url}scripts/lastStatuses/${scriptId}`);
  }
}
